import React, { useEffect } from 'react';
import { initMetaPixel } from './hooks/useMetaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { RoadmapSection } from './components/RoadmapSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-blanco-hueso font-body text-negro-carbon leading-[1.7]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <PainSection data-id="element-3" />
      <RoadmapSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <OfferSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <FaqSection data-id="element-9" />
      <FinalCtaSection data-id="element-10" />
      <Footer data-id="element-11" />
      <ExitIntentPopup data-id="element-12" />
      <SocialProofPopup data-id="element-13" />
    </div>;
}